import {GridTypeMap, StandardTextFieldProps} from "@mui/material";
import {SelectOptions} from "../GenericSelect";
import {ListQuery, ListRequest, ListResponseType} from "../../../app/api/types";
import {FormikProps} from "formik";

export enum InputFieldType {
    TEXT = "text",
    COUNTRY = "country",
    LANGUAGE = "language",
    HIDDEN = "hidden",
    DATE = "date",
    NUMBER = "number",
    INTEGER = "integer",
    SELECT = "select",
    SELECT_FROM_REQUEST = "select_from_request",
    STAGE_SELECT = "stage_select",
    ORGANIZATION_STAGE_SELECT = "organization_stage_select",
    CHECKBOX = "checkbox",
    READ_ONLY = "read_only",
}

export interface InputField<T, V extends ListResponseType, U extends ListRequest>
    extends Pick<
        StandardTextFieldProps,
        "disabled" | "id" | "inputProps" | "multiline" | "required" | "sx" | "minRows"
    > {
    selectOptions?: SelectOptions[];
    query?: ListQuery<V, U>;
    request?: U;
    translationKey: string;
    fieldName: keyof T;
    subFieldName?: string;
    gridProps?: GridTypeMap["props"];
    type?: InputFieldType;
    render?: (renderProps: InputFieldRenderProps<T, V, U>) => JSX.Element;
    fieldProps?: {[key: string]: any};
    valueField?: keyof V;
    optionLabelField?: keyof V;
}

export interface InputFieldRenderProps<T, V extends ListResponseType, U extends ListRequest> {
    inputField: InputField<T, V, U>;
    form: FormikProps<Partial<T>>;
}
